import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-subscription-welcome-modal',
  templateUrl: './subscription-welcome-modal.component.html',
  styleUrls: ['./subscription-welcome-modal.component.scss'],
})
export class SubscriptionWelcomeModalComponent implements OnInit {
  constructor(private dynamicDialogRef: DynamicDialogRef) {}

  ngOnInit() {}
  /**
   * Close modal and send data back to parent component
   *
   * @param isSuccess
   * @param isSubscriptionRequested
   */
  close(isSuccess: boolean, isSubscriptionRequested?: boolean) {
    this.dynamicDialogRef.close({ isSuccess, isSubscriptionRequested });
  }
}
